import { render } from "./DireitosHumanos.vue?vue&type=template&id=9b543648&scoped=true"
import script from "./DireitosHumanos.vue?vue&type=script&lang=js"
export * from "./DireitosHumanos.vue?vue&type=script&lang=js"

import "./DireitosHumanos.vue?vue&type=style&index=0&id=9b543648&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9b543648"]])

export default __exports__